
'use strict';

/* Controllers */

angular.module('FlexyBeautyApp.controllers')
    .controller('ReportAloneCtrl',['$scope','$routeParams','ReportModelData','TaxMode','StatPeriodType','PeriodType','PeriodStat','ReportView','CategoryData','ProductCategoryData','CureCategoryData','LoyaltyCardCategoryData',
        'TypeOfSale','DashboardData','moment',
        function($scope, $routeParams, ReportModelData, TaxMode, StatPeriodType,PeriodType,PeriodStat,ReportView,CategoryData,ProductCategoryData,CureCategoryData,LoyaltyCardCategoryData,TypeOfSale,DashboardData,moment){

            $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
                if (newValue) {
                    $scope.reportId = $routeParams.idReport;
                    $scope.beginDayId = $routeParams.beginDayId;
                    $scope.endDayId = $routeParams.endDayId;
                    $scope.dashboardId = $routeParams.dashboardId;
                    $scope.indexReport = $routeParams.indexReport;
                    $scope.dashboardModel = null;

                    $scope.reportModel = ReportModelData.getById($scope.reportId);
                    $scope.reportChanges = null;
                    if($scope.dashboardId)
                        $scope.dashboardModel = DashboardData.getById($scope.dashboardId);

                    if($scope.dashboardModel) {
                        var reports = angular.fromJson($scope.dashboardModel.jsonDetail);
                        for (var i = 0; i < reports.length; i++) {
                            if(reports[i].reportModelId === $scope.reportId && i == $scope.indexReport) {
                                $scope.reportChanges = reports[i].reportChanges;
                            }
                        }
                    }

                    $scope.taxMode = TaxMode.TTC;
                    $scope.reportView = new ReportView($scope.reportModel, $scope.reportChanges, $scope.taxMode, null, null);

                    $scope.begin = moment($scope.beginDayId, "YYYYMMDD");
                    $scope.end = moment($scope.endDayId, "YYYYMMDD");

                    $scope.currentPeriod = new PeriodStat(StatPeriodType.CURRENT, $scope.begin, $scope.end, PeriodType.CUSTOMED);

                    CategoryData.categoryRoot.label = TypeOfSale.SERVICE.label;
                    ProductCategoryData.categoryRoot.label = TypeOfSale.PRODUCT.label;
                    CureCategoryData.categoryRoot.label = TypeOfSale.CURE.label;
                    LoyaltyCardCategoryData.categoryRoot.label = TypeOfSale.LOYALTY.label;

                    $scope.pastPeriod = new PeriodStat(
                        StatPeriodType.PAST,
                        PeriodStat.getLastYearCorrespondingDay($scope.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.currentPeriod.periodType),
                        PeriodType.getLastDayOfPeriod($scope.currentPeriod.periodType, PeriodStat.getLastYearCorrespondingDay($scope.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.currentPeriod.periodType), $scope.currentPeriod.arrayOfDays.length),
                        PeriodType.CUSTOMED
                    );

                    $scope.reportView.getDataSource().loadPeriod($scope.currentPeriod, $scope.pastPeriod, $scope.taxMode);
                }
            });
        }
    ]);








// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/reportAloneCtrl.js